import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import Support from "../components/Support";

const mapStateToProps = state => ({});
const mapDispatchToProps = dispatch => ({});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Support);
const withTranslationComponent = withTranslation(["support", "common"])(connectedComponent);

export default withTranslationComponent;


/*
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import * as actions from "../constants/actions";
import Support from "../components/Support";

const mapStateToProps = state => ({
  ui: state.ui
});

const mapDispatchToProps = dispatch => ({
  showUISupportCard: () => dispatch(actions.showUISupportCard()),
  hideUISupportCard: () => dispatch(actions.hideUISupportCard())
});

const connectedComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(Support);
const withTranslationComponent = withTranslation(["support", "common"])(connectedComponent);

export default withTranslationComponent;
*/



// WEBPACK FOOTER //
// ./src/containers/Support.js